import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { Router } from '@angular/router';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlockUIModule } from 'ng-block-ui';

import { routes } from './app.routes';
import { AppComponent } from './components/app/app.component';

// App views
import { TristateModule } from './components/common/tristatedropdown/tristate.module';
import { YearselectorModule } from './components/common/yearselector/yearselector.module';
import { UserAccountModule } from './views/userAccounts/userAccounts.module';
import { ErrorModule } from './views/error/error.module';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RegistrationModule } from './views/registration/registration.module';
import { TendersModule } from './views/tenders/tenders.module'
import { SubscriptionModule } from './views/subscription/subscription.module';
import { TenderTeamMemberModule } from './views/tender.team.members/tender.team.member.module';
import { ContractAwardsModule } from './views/contract.awards/contract.awards.module';
//import { AlertModule } from 'ngx-bootstrap/alert';
import { AccountManagementModule } from './views/account.management/account.management.module';

// App modules/components
import { LayoutsModule } from './components/common/layouts/layouts.module';
import { Configuration } from './configuration';
import { Helpers, CategoryAndLocationHelpers } from './helpers';

//Authentication
import { AuthModule } from './auth/auth.module';

//Services
import { ServiceModule } from './services/service.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalHttpClient } from './global.http.client';
import { BaseUrlInterceptor } from './interceptors/base.url.interceptor';
import { TokenInterceptor } from './auth/token.interceptor';
import { ResponseInterceptor } from './interceptors/response.interceptor';
import { B2BAngularMaterialModule } from './components/common/angular.material/b2b.angular.material.module';
import { SignalRModule } from './signalr/signalr.module';
import { CompetitorsModule } from './views/competitors/competitors.module';
import { TrainingModule } from './views/training/training.module';
import { ResourcesModule } from './views/resources/resources.module';
import { PaidFeatureUpsellModule } from './components/common/paid.feature.upsell/paid.feature.upsell.module';

export const angularPlugin = new AngularPlugin();
export const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: 'a5868385-7bd7-44e3-a62f-ff028e1fca0b',
        extensions: [angularPlugin],
        extensionConfig: {
            // Temporary router placeholder; we’ll set it properly in AppModule constructor
            [angularPlugin.identifier]: {
                router: null
            }
        }
    }
});

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        // Must be first import
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        HttpClientJsonpModule,

        //Authentication/Authorization
        AuthModule,

        //Services
        ServiceModule,

        //SignalR
        SignalRModule,

        // Views
        TristateModule,
        YearselectorModule,
        UserAccountModule,
        ErrorModule,
        RegistrationModule,
        TendersModule,
        SubscriptionModule,
        TenderTeamMemberModule,
        ContractAwardsModule,
        AccountManagementModule,
        CompetitorsModule,
        TrainingModule,
        ResourcesModule,

        // Modules
        LayoutsModule,
        SimpleNotificationsModule.forRoot(),
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'top',
            anchorScrolling: 'enabled'
        }),
        //AlertModule.forRoot(),
        BlockUIModule.forRoot({
            message: 'Loading'
        }),
        FormsModule,
        ReactiveFormsModule,
        //AlertModule,
        B2BAngularMaterialModule,
        PaidFeatureUpsellModule
    ],
    providers: [
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        // Interceptor to automatically append the base url
        // Only if the url format does not contain "http"
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BaseUrlInterceptor,
            multi: true
        },
        // Interceptor to add the token on unless url is on the list of urls to ignore
        // Urls for token to ignore are found in the Configuration
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        // Interceptor to check for a response error code
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ResponseInterceptor,
            multi: true
        },
        GlobalHttpClient,
        Configuration,
        Helpers,
        CategoryAndLocationHelpers
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
    constructor(router: Router) {
        const angularPluginConfig = appInsights.config.extensionConfig[angularPlugin.identifier];
        if (angularPluginConfig) {
            angularPluginConfig.router = router;
        }
        appInsights.loadAppInsights();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/app.module.ts